// How George works with AI coding agents. Rendered by AiApproach.jsx.
export const aiSection = {
  title: 'How I Work with AI',
  intro:
    'I treat AI agents as a delivery team I direct, not a tool I prompt. Every piece of work moves from spec to merge through the same disciplined loop.',
  stack:
    'My stack: Hermes for orchestration, Composio for tool integrations, Claude Code for implementation, and OpenAI models across the workflow.',
};

export const aiPractices = [
  {
    lead: 'Start from the spec',
    text: 'The agent analyses the requirements and shapes them into clear milestones, each with a defined outcome and a plan for tracking progress.',
  },
  {
    lead: 'Break it down with the ticketing system',
    text: 'My agent connects directly to the ticketing system. It proposes how each milestone splits into stories, and I refine the breakdown before anything is built.',
  },
  {
    lead: 'Plan before code',
    text: 'Every story gets a written implementation plan that is reviewed and approved before a single line is written. The plan is a file, so it survives every re-run.',
  },
  {
    lead: 'Work in isolation',
    text: 'Agents run in separate branches and worktrees, so parallel work never collides. For bigger changes, I run several directions side by side and pick the strongest.',
  },
  {
    lead: 'Build to standard',
    text: 'Each plan specifies unit and integration tests, coding standards and hard constraints. Every repo carries a CLAUDE.md so the agent inherits the architecture instead of guessing it.',
  },
  {
    lead: 'Secure by default',
    text: 'Agents run with scoped permissions and never touch secrets or production systems.',
  },
  {
    lead: 'Verify, don’t trust',
    text: 'An agent’s report is a claim, not evidence. I rerun the builds and tests myself and check the shipped artifact, not just the source.',
  },
  {
    lead: 'Review twice, then merge',
    text: 'AI does the first review pass. I do the second. Nothing reaches main without both.',
  },
  {
    lead: 'Compound with skills',
    text: 'Repeated work becomes a reusable skill, and every review finding feeds back into the standards, so each delivery is faster and more consistent than the last.',
  },
];
